import { useLoading } from '@/providers/LoadingProvider';

export const ModalLoading = () => {
  const { showLoading } = useLoading();

  if (showLoading) {
    return (
      <div className="cover-loading">
        <div className="spinner-border text-info" role="status">
          <span className="sr-only"></span>
        </div>
      </div>
    );
  } else {
    return <></>;
  }
};
